import { useSelector } from 'react-redux';
import DEFAULT_SALES_MARKET_LANG from 'constants/defaultSalesMarketLang';

const useGetSalesMarketLang = () =>
  useSelector(
    ({ Brands }) =>
      Brands.brand.multinational.salesMarket || DEFAULT_SALES_MARKET_LANG
  );

export default useGetSalesMarketLang;
